// extracted by mini-css-extract-plugin
export default {"form-container":"AuditLogPage_form-container__fKR-C","middle-div-container":"AuditLogPage_middle-div-container__ScQz0","table-container":"AuditLogPage_table-container__jMfbC"};